module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dRw9B"))).then(() => module.bundle.root('ljYL6'));